import { render, staticRenderFns } from "./BlockTypeIcon.vue?vue&type=template&id=e11ebc88&"
import script from "./BlockTypeIcon.vue?vue&type=script&lang=js&"
export * from "./BlockTypeIcon.vue?vue&type=script&lang=js&"
import style0 from "./BlockTypeIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports